import DisplayReplyAllAction from '../cardActions/DisplayReplyAllFormAction';
import InvokeAddInCommandAction from '../cardActions/InvokeAddinCommandAction';
import * as Adaptive from 'adaptivecards';
import { ActionProvider } from 'owa-actionable-message';

export default function parseLegacyMessageCardAction(
    jsonAction: any,
    actionProviders: ActionProvider[]
): Adaptive.Action {
    switch (jsonAction['@type'].toLowerCase()) {
        case 'displayreplyallform':
            return parseDisplayReplyAllFormAction(jsonAction);
        case 'invokeaddincommand':
            return parseInvokeAddInCommandAction(jsonAction);
    }

    return null;
}

function parseInvokeAddInCommandAction(json: any): InvokeAddInCommandAction {
    const action = new InvokeAddInCommandAction();
    action.title = json.name;
    action.addinId = json.addInId;
    action.desktopCommandId = json.desktopCommandId;
    action.initializationContext = JSON.stringify(json.initializationContext);

    return action;
}

function parseDisplayReplyAllFormAction(json: any): DisplayReplyAllAction {
    const action = new DisplayReplyAllAction();
    action.title = json.name;
    action.htmlBody = json.htmlBody;

    return action;
}
